import { ReactNode, useEffect, useMemo, useRef } from 'react'

import createQueryParams from 'common/use-query-params'

type Props = {
  children?: ReactNode
  submit?: boolean
}

const useQueryParams = createQueryParams({
  challenge: 'challenge',
  clientId: 'client_id',
  redirectUri: 'redirect_uri',
  responseType: 'response_type',
  state: 'state',
})

const OAuthForm = ({ children, submit }: Props) => {
  const formRef = useRef<HTMLFormElement>(null)
  const { challenge = '', clientId = '', redirectUri = '', responseType = '', state = '' } = useQueryParams()

  useEffect(() => {
    if (submit === true && formRef.current) {
      formRef.current.submit()
    }
  }, [submit, formRef])

  const action = useMemo(() => {
    const q = new URLSearchParams({
      challenge,
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: responseType,
      state,
    })

    return `/api/oauth2/authorize?${q}`
  }, [challenge, clientId, redirectUri, responseType, state])

  return (
    <form
      ref={formRef}
      action={action}
      method="POST"
    >
      {children}
    </form>
  )
}
export default OAuthForm
